import React from "react";
import { Stack, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";

import { StyledItemRow } from "./styles";
import {
  calculations,
  getQuoteFormValues,
  resolveCalculations,
  formatValue,
} from "./helper";
import useQuoteEntities from "./useQuoteEntities";

const ItemFields = ({ data = {} }) => {
  const { watch } = useFormContext();
  const entities = useQuoteEntities();

  const formValues = {
    ...getQuoteFormValues(watch, entities),
    ...data,
  };

  const results = resolveCalculations(formValues);

  return (
    <>
      {calculations.map((calc, idx) => (
        <StyledItemRow
          key={calc.id}
          highlight={calc?.highlight}
          {...(idx === calculations?.length - 1
            ? { sx: { borderBottom: 0 } }
            : {})}
        >
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Stack>
              <Typography
                variant="caption"
                fontWeight={600}
                className="ItemCell-root"
              >
                {calc.label}
              </Typography>
              {calc.subtitle && (
                <Typography
                  variant="caption"
                  className="ItemCell-root, ItemCell-subtitle"
                >
                  {calc.subtitle}
                </Typography>
              )}
            </Stack>
          </Stack>
          <Typography
            variant="caption"
            fontWeight={700}
            sx={{ padding: "0 5px" }}
            textAlign="right"
          >
            {formatValue(results[calc.id], calc.type)}
          </Typography>
        </StyledItemRow>
      ))}
    </>
  );
};

export default ItemFields;
